import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isNull, isEqual, isArray } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

//import ViewDataDictionary from "../components/ViewDataDictionary";
//import ViewStructure from "../components/ViewStructure";
import Buffering from "../components/Buffering";


//import { getDataDictionaryVersion, getDataDictionaryVersionStructures, zipDataDictionary } from "../utils/utilsDataDictionary";
//import { getVersion  } from "../utils";

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'

const normalizeAssetPath = (path) => {
    if (typeof path !== "string") {
        return path;
    }

    if (
        path.startsWith("./") ||
        path.startsWith("../") ||
        path.startsWith("/") ||
        path.startsWith("#") ||
        /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(path)
    ) {
        return path;
    }

    return `./${path}`;
};

const normalizeAssets = (assets = {}) => {
    const normalized = {};

    for (const [path, value] of Object.entries(assets || {})) {
        const normalizedPath = normalizeAssetPath(path);

        // Prefer canonical ./path key if both variants exist.
        if (!(normalizedPath in normalized)) {
            normalized[normalizedPath] = value;
        }
    }

    return normalized;
};

class ViewVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idDataDictionary: null,
            type: null,
            isLoaded: false,
            isFailed: false, 
            loadData: false,

            Controls: {
            },

        }

        StateChange.mdPage = getParam('mdPage', this.props)

        this.setState(StateChange);

    }






    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.mdPage){
            const normalizedAssets = normalizeAssets(this.props.assets);

            return(
                <VersionRenderMarkdown assets={normalizedAssets}>
                    {this.state.mdPage}
                </VersionRenderMarkdown>
            )
        }
        return null;

    };    



};


class VersionRenderMarkdown extends React.Component {

    getExplicitlyLinkedAssetPaths() {
        const markdown = typeof this.props.children === "string"
            ? this.props.children
            : "";

        const linkedPaths = new Set();

        // Markdown links: [label](path)
        const markdownLinkRegex = /\[[^\]]*\]\(([^)\s]+)(?:\s+"[^"]*")?\)/g;
        let match = null;
        while ((match = markdownLinkRegex.exec(markdown)) !== null) {
            linkedPaths.add(match[1]);
            linkedPaths.add(normalizeAssetPath(match[1]));
        }

        // Raw HTML links: <a href="path">...
        const htmlLinkRegex = /<a\s+[^>]*href=["']([^"']+)["'][^>]*>/gi;
        while ((match = htmlLinkRegex.exec(markdown)) !== null) {
            linkedPaths.add(match[1]);
            linkedPaths.add(normalizeAssetPath(match[1]));
        }

        return linkedPaths;
    }

    resolveRendition(path) {
        const normalizedPath = normalizeAssetPath(path);
        return this.props.assets?.[path] ?? this.props.assets?.[normalizedPath];
    }

    renditionId(path) {
        return `rendition-${path
            .replace("./", "")
            .replace(/[^a-zA-Z0-9_-]/g, "-")}`;
    }

    scrollToId(id, href) {
        const el = document.getElementById(id);

        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

            window.history.replaceState(
                null,
                "",
                `${window.location.pathname}${window.location.search}${href}`
            );
        }
    }

    renderRenditions() {
        const renditions = this.props.assets || {};
        const linkedPaths = this.getExplicitlyLinkedAssetPaths();

        const linkedRenditions = Object.entries(renditions)
            .filter(([path]) => !path.endsWith(".svg") && linkedPaths.has(path));

        if (linkedRenditions.length === 0) {
            return null;
        }

        return (
            <div className="version-renditions">
                <hr />

                <h2>Renditions</h2>

                {linkedRenditions.map(([path, value]) => (
                    <section
                        key={path}
                        id={this.renditionId(path)}
                    >
                        <h3>{path.replace("./", "")}</h3>

                        <pre>
                            <code>
                                {typeof value === "string"
                                    ? value
                                    : JSON.stringify(value, null, 2)}
                            </code>
                        </pre>
                    </section>
                ))}
            </div>
        );
    }

    render() {
        return (
            <>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{

                        // Render images from embedded renditions
                        img: ({ src, alt }) => {
                            const rendition = this.resolveRendition(src);

                            if (rendition && src.endsWith(".svg")) {
                                return (
                                    <img
                                        src={`data:image/svg+xml;utf8,${encodeURIComponent(rendition)}`}
                                        alt={alt}
                                    />
                                );
                            }

                            return (
                                <img
                                    src={src}
                                    alt={alt}
                                />
                            );
                        },

                        // Render links
                        a: ({ node, href, children, ...props }) => {

                            // Preserve anchor targets like:
                            // <a id="some-id"></a>
                            if (!href) {
                                return (
                                    <a {...props}>
                                        {children}
                                    </a>
                                );
                            }

                            // Internal page anchors
                            if (href.startsWith("#")) {
                                return (
                                    <a
                                        {...props}
                                        href={href}
                                        onClick={(e) => {
                                            e.preventDefault();

                                            const id =
                                                decodeURIComponent(
                                                    href.slice(1)
                                                );

                                            this.scrollToId(id, href);
                                        }}
                                    >
                                        {children}
                                    </a>
                                );
                            }

                            // Internal rendition links
                            const rendition =
                                this.resolveRendition(href);

                            if (rendition && !href.endsWith(".svg")) {
                                const id =
                                    this.renditionId(href);

                                const renditionHref =
                                    `#${id}`;

                                return (
                                    <a
                                        {...props}
                                        href={renditionHref}
                                        onClick={(e) => {
                                            e.preventDefault();

                                            this.scrollToId(
                                                id,
                                                renditionHref
                                            );
                                        }}
                                    >
                                        {children}
                                    </a>
                                );
                            }

                            // External links
                            return (
                                <a
                                    {...props}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {children}
                                </a>
                            );
                        }

                    }}
                >
                    {this.props.children}
                </ReactMarkdown>

                {this.renderRenditions()}
            </>
        );
    }
}




export default function ViewVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewVersion {...props} navigation={navigation} location={location} params={params} />;
  }
